// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("jquery") //jQueryを追加
require("bootstrap") //Bootstrapを追加
//require('jquery')

// ファイル追加
require ('image')
require ('base')
require ('item')
require ('room')
require ('form')

import "./fontawesome-free/regular.js"
import "./fontawesome-free/brands.js"
import "./fontawesome-free/fontawesome.js"
import "./fontawesome-free/solid.js"

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)